export const setRooms = (rooms) => ({
   type: 'SET_ROOMS',
   payload: rooms,
 });
 